// Script Files
import '../scss/theme-style.scss';
import './components/header';
import './components/before-after';
import './components/yoast-faqs';
import './animation/gsap';
import './utils/generic';
